import * as actionTypes from "./actionTypes";
import * as types from "./types";

// POST Data Loader 

export const postDataLoaderRequest = (
    payload: types.IDataLoaderPostReq
): types.PostDataLoaderRequest => ({
    type: actionTypes.POST_DATALOADER_REQUEST,
    payload
});

export const postDataLoaderReset = (
): types.PostDataLoaderReset => ({
    type: actionTypes.POST_DATALOADER_RESET,
});

export const postDataLoaderSuccess = (
    payload: types.IPostDataLoaderSuccessPayload
): types.PostDataLoaderSuccess => ({
    type: actionTypes.POST_DATALOADER_SUCCESS,
    payload,
});

export const postDataLoaderFailure = (
    payload: types.IPostDataLoaderFailurePayload
): types.PostDataLoaderFailure => ({
    type: actionTypes.POST_DATALOADER_FAILURE,
    payload,
});


// PUT Data Loader 

export const putDataLoaderRequest = (
    batchCode: string,
    payload: types.IDataLoaderPutReq
): types.PutDataLoaderRequest => ({
    type: actionTypes.PUT_DATALOADER_REQUEST,
    batchCode,
    payload
});

export const putDataLoaderSuccess = (
    payload: types.IPutDataLoaderSuccessPayload
): types.PutDataLoaderSuccess => ({
    type: actionTypes.PUT_DATALOADER_SUCCESS,
    payload,
});

export const putDataLoaderFailure = (
    payload: types.IPutDataLoaderFailurePayload
): types.PutDataLoaderFailure => ({
    type: actionTypes.PUT_DATALOADER_FAILURE,
    payload,
});

export const putDataLoaderReset = (
    ): types.PutDataLoaderReset => ({
        type: actionTypes.PUT_DATALOADER_RESET,
    });


// GET all Data Loaders

export const fetchLoadersReq = (params: types.ISearchParam): types.FetchLoadersReq => ({
    type: actionTypes.FETCH_LOADERS_LIST_REQUEST,
    params,
});

export const fetchLoadersSuccess = (
    payload: types.FetchLoadersSuccessPayload
): types.FetchLoadersSuccess => ({
    type: actionTypes.FETCH_LOADERS_LIST_SUCCESS,
    payload,
});

export const fetchLoadersFailure = (
    payload: types.FetchLoadersFailurePayload
): types.FetchLoadersFailure => ({
    type: actionTypes.FETCH_LOADERS_LIST_FAILURE,
    payload,
});


// GET Data Loader

export const fetchLoaderDetailsReq = (params: string): types.FetchLoaderDetailsReq => ({
    type: actionTypes.FETCH_LOADER_REQUEST,
    params,
});

export const fetchLoaderDetailsSuccess = (
    payload: types.FetchLoaderDetailsSuccessPayload
): types.FetchLoaderDetailsSuccess => ({
    type: actionTypes.FETCH_LOADER_SUCCESS,
    payload,
});

export const fetchLoaderDetailsFailure = (
    payload: types.FetchLoaderDetailsFailurePayload
): types.FetchLoaderDetailsFailure => ({
    type: actionTypes.FETCH_LOADER_FAILURE,
    payload,
});


// DELETE Loader

export const deleteLoaderReq = (
    payload: types.IDeleteParams
): types.DeleteLoaderRequest => ({
    type: actionTypes.DELETE_LOADER_REQUEST,
    payload,
});

export const deleteLoaderSuccess = (
    payload: types.IDeleteLoaderSuccessPayload
): types.DeleteLoaderSuccess => ({
    type: actionTypes.DELETE_LOADER_SUCCESS,
    payload,
});

export const deleteLoaderFailure = (
    payload: types.IDeleteLoaderFailurePayload
): types.DeleteLoaderFailure => ({
    type: actionTypes.DELETE_LOADER_FAILURE,
    payload,
});


// Fetch extractor status
export const fetchLoaderStatusReq = (params: string): types.FetchLoaderStatusReq => ({
    type: actionTypes.FETCH_LOADER_STATUS_REQUEST,
    params,
});

export const fetchLoaderStatusSuccess = (  
    payload: types.FetchLoaderStatusSuccessPayload
): types.FetchLoaderStatusSuccess => ({
    type: actionTypes.FETCH_LOADER_STATUS_SUCCESS,    
    payload,
});

export const fetchLoaderStatusFailure = (
    payload: types.FetchLoaderStatusFailurePayload
): types.FetchLoaderStatusFailure => ({
    type: actionTypes.FETCH_LOADER_STATUS_FAILURE,
    payload,
});